export default {
  getTagsList: ({ tags }) => tags && tags.length && [...tags[0]].sort((a, b) => ((a.name > b.name) ? 1 : -1)) || [],
  getObjectTags: ({ tagsUsers }) => (id) => tagsUsers[id] && [...tagsUsers[id]].sort(
    (a, b) => ((a.name > b.name) ? 1 : -1),
  ),
}
